// src/services/firebase/settingsService.js
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './config';

// Varsayılan smart rules
const defaultSmartRules = {
  preventConflictingActions: true,
  prioritizeParentActions: true,
  minTransactionAmount: 100,
  maxTransactionPercentage: 20,
  rebalancePriority: ['STOCK', 'ETF', 'BOND', 'COMMODITIES', 'CASH']
};

// Varsayılan rebalance ayarları
export const defaultRebalanceSettings = {
  threshold: 5,
  targetBudget: 1000000,
  budgetWarningThreshold: 10,
  smartRules: defaultSmartRules
};

// Smart rules'u kaydet
export const saveSmartRules = async (userEmail, rules) => {
  if (!userEmail) {
    console.error('User email is required');
    return false;
  }

  try {
    const settingsRef = doc(db, 'users', userEmail, 'settings', 'rebalance');
    const currentSettingsDoc = await getDoc(settingsRef);
    const currentSettings = currentSettingsDoc.exists() ? currentSettingsDoc.data() : defaultRebalanceSettings;
    
    await setDoc(settingsRef, {
      ...currentSettings,
      smartRules: {
        ...defaultSmartRules,
        ...rules
      },
      lastModifiedBy: userEmail,
      updatedAt: new Date()
    });

    console.log(`Smart rules saved for user: ${userEmail}`);
    return true;
  } catch (error) {
    console.error('Error saving smart rules:', error);
    throw new Error(`Smart rules kaydedilirken hata oluştu: ${error.message}`);
  }
};

// Rebalance ayarlarını al
export const getRebalanceSettings = async (userEmail) => {
  if (!userEmail) {
    console.error('User email is required');
    return defaultRebalanceSettings;
  }

  try {
    const settingsRef = doc(db, 'users', userEmail, 'settings', 'rebalance');
    const settingsDoc = await getDoc(settingsRef);
    const userSettings = settingsDoc.exists() ? settingsDoc.data() : {};
      
    // Varsayılan ve kullanıcı ayarlarını birleştir
    const mergedSettings = {
      ...defaultRebalanceSettings,
      ...userSettings,
      smartRules: {
        ...defaultSmartRules,
        ...(userSettings.smartRules || {})
      }
    };

    return mergedSettings;
  } catch (error) {
    console.error('Error loading settings:', error);
    // Hata durumunda varsayılan ayarları döndür
    return defaultRebalanceSettings;
  }
};

// Rebalance ayarlarını güncelle
export const updateRebalanceSettings = async (userEmail, newSettings) => {
  if (!userEmail) {
    console.error('User email is required');
    return false;
  }

  try {
    const settingsRef = doc(db, 'users', userEmail, 'settings', 'rebalance');
    
    // Mevcut ayarları al
    const currentSettingsDoc = await getDoc(settingsRef);
    const currentSettings = currentSettingsDoc.exists() ? currentSettingsDoc.data() : defaultRebalanceSettings;

    // Yeni ayarları mevcut ayarlarla birleştir
    const updatedSettings = {
      ...currentSettings,
      ...newSettings,
      smartRules: {
        ...defaultSmartRules,
        ...(currentSettings.smartRules || {}),
        ...(newSettings.smartRules || {})
      },
      lastModifiedBy: userEmail,
      updatedAt: new Date()
    };

    await setDoc(settingsRef, updatedSettings);
    
    console.log(`Settings updated for user: ${userEmail}`);
    return true;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw new Error(`Ayarlar güncellenirken hata oluştu: ${error.message}`);
  }
};